import React, { useEffect, useRef, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Header from '../../components/Header';
import Nav from '../../components/Nav';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { setLoading } from '../../redux/actions/loader.action';
import axios from 'axios';
import { logout } from '../../redux/actions/auth.action';
import { dateFormat, endpoint, endpointApi } from '../../utils';
import { getExpenses } from '../../redux/actions/expense.action';
import Paginate from '../../components/Paginate';

export default function ExpensesPage() {
    const jwt_access = localStorage.getItem('jwt_access');
    const { me } = useSelector(state => state.auth);
    const expenses = useSelector(state => state.expenses);
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const addModalRef = useRef(null);
    const updateModalRef = useRef(null);
    const detailsModalRef = useRef(null);

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    const [year, setYear] = useState((new Date()).getFullYear());
    const [yearsOptions, setYearsOptions] = useState([]);

    const [modal, setModal] = useState(null);
    const [actionModal, setActionModal] = useState(null);

    const [expense, setExpense] = useState(null);
    const [date, setDate] = useState("");
    const [status, setStatus] = useState("");
    const [label, setLabel] = useState("");
    const [description, setDescription] = useState("");
    const [quantity, setQuantity] = useState("");
    const [unitPrice, setUnitPrice] = useState("");
    const [totalAmount, setTotalAmount] = useState("");
    const [isDateTouched, setIsDateTouched] = useState(false);
    const [isStatusTouched, setIsStatusTouched] = useState(false);
    const [isLabelTouched, setIsLabelTouched] = useState(false);
    const [isDescriptionTouched, setIsDescriptionTouched] = useState(false);
    const [isQuantityTouched, setIsQuantityTouched] = useState(false);
    const [isUnitPriceTouched, setIsUnitPriceTouched] = useState(false);
    const [errors, setErrors] = useState(null);

    useEffect(() => {
        if(unitPrice && quantity){
            setTotalAmount(unitPrice * quantity);
        }else{
            setTotalAmount("");
        }
    }, [unitPrice, quantity]);

    useEffect(() => {
        if((new Date()).getFullYear() > 2024){
          for(let i = (new Date()).getFullYear(); i >= 2024; i--){
            setYearsOptions(options => [...options, i]);
          }
        }else{
          setYearsOptions([2024]);
        }
    }, []);

    useEffect(() => {
        if(year === ""){
            setYear((new Date()).getFullYear());
        }
    }, [year]);

    useEffect(() => {
        if(startDate && endDate){
            const startDateTemp = new Date(startDate);
            const endDateTemp = new Date(endDate);

            if (endDateTemp >= startDateTemp) {
                navigate(`/expenses?start_date=${ startDate }&end_date=${ endDate }`)
            }else{
                navigate(`/expenses`);
            }
        }
    }, [startDate, endDate, year, navigate]);

    useEffect(() => {
        dispatch(getExpenses(location, navigate, year));
    }, [location, dispatch, navigate, year]);

    useEffect(() => {
        const clickOutsideModal = (e) => {
            if(addModalRef.current === e.target || updateModalRef.current === e.target || detailsModalRef.current === e.target || e.target.classList.contains('_modal-close')){
                setModal(null);
            }
        }

        document.addEventListener('click', clickOutsideModal);
        return () => {
            document.removeEventListener('click', clickOutsideModal);
        }
    }, []);

    useEffect(() => {
        const clickOutsideActionModal = (e) => {
            const $actionModals = document.querySelectorAll('.actions>ul');
            $actionModals.forEach($actionModal => {
                if($actionModal && !$actionModal.contains(e.target) && $actionModal.classList.contains('active')){
                    setActionModal(null);
                }
            });
        }
        document.addEventListener('click', clickOutsideActionModal);
        return () => {
            document.removeEventListener('click', clickOutsideActionModal);
        }
    }, []);

    useEffect(() => {
        if(modal !== 'update'){
            if(modal === null)
                setExpense(null);
            setDate("");
            setStatus("");
            setLabel("");
            setDescription("")
            setQuantity("");
            setUnitPrice("");
            setTotalAmount("");
            setIsStatusTouched(false);
            setIsDateTouched(false);
            setIsLabelTouched(false);
            setIsDescriptionTouched(false);
            setIsQuantityTouched(false);
            setIsUnitPriceTouched(false);
            setErrors(null);
        }
    }, [modal]);
    
    useEffect(() => {
        if(modal === 'update' && expense){
            setDate(expense.date);
            setLabel(expense.label);
            setDescription(expense.description ? expense.description : '')
            setQuantity(expense.quantity);
            setUnitPrice(expense.unit_price);
            setTotalAmount(expense.total_amount);
            setStatus(expense.status);
        }
    }, [modal, expense]);

    const handleSubmit = async(e) => {
        e.preventDefault();
        dispatch(setLoading(true));
        setErrors(null);
        const data = new FormData(e.target);
        await axios.post(`${ endpointApi }expenses`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ jwt_access }`
            }
        }).then(({ data }) => {
            dispatch(getExpenses(location, navigate));
            setExpense(data);
            setModal("details");
        }).catch(err => {
            if(err.response.status === 401){
                dispatch(logout(location.pathname + location.search, navigate));
            }else{
                setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                const $modals = document.querySelectorAll('._modal-content');
                $modals.forEach($modal => {
                    $modal.scrollTop = 0;
                });
            }
        })
        .finally(() => {
            dispatch(setLoading(false));
        }); 
    }
    
    const handleSubmit2 = async(e) => {
        e.preventDefault();
        dispatch(setLoading(true));
        setErrors(null);
        const data = new FormData(e.target);
        await axios.put(`${ endpointApi }expenses/${ expense?.id }`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ jwt_access }`
            }
        }).then(({ data }) => {
            dispatch(getExpenses(location, navigate));
            setExpense(data);
            setModal("details");
        }).catch(err => {
            if(err.response.status === 401){
                dispatch(logout(location.pathname + location.search, navigate));
            }else{
                setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                const $modals = document.querySelectorAll('._modal-content');
                $modals.forEach($modal => {
                    $modal.scrollTop = 0;
                });
            }
        })
        .finally(() => {
            dispatch(setLoading(false));
        }); 
    }

    useEffect(() => {
        if(!jwt_access){
          navigate('/login?redirect_to=' + location.pathname + location.search);
        }
    }, [location, navigate, jwt_access]);

    return (
        me &&
        <HelmetProvider>
            <Helmet>
                <title>Historique des dépenses - Société Mikalo</title>
            </Helmet>

            <Header />

            <Nav />

            <main id="main">
                <div className='title d-flex justify-content-between'>
                    <h1>Historique des dépenses</h1>
                    <button type='button' onClick={ () => {
                        setModal('add');
                    } } className='btn btn-primary'><i className='fa fa-plus'></i> Ajouter</button>
                </div>

                <div className='mb-4 d-flex align-items-center justify-content-between'>
                    <form className='form'> 
                        <label htmlFor='year'>Année:</label>
                        <select className='form-control' required value={ year } onChange={ (e) => setYear(e.target.value) }>
                            <option value="">Sélectionner...</option>
                            { yearsOptions.map(year => {
                            return(
                                <option value={ year } key={ year }>{ year }</option>
                            )
                            })}
                        </select>
                    </form>
                    <a href={ `${ endpoint }export/expenses-per-month/${ year }` } target='_blank' rel="noreferrer" className='btn btn-primary'><i className='fa fa-file-excel'></i> Télécharger le fichier Excel</a>
                </div>

                <div ref={ addModalRef } className={ `_modal${ modal === 'add' ? ' active' : '' }` }>
                    <div className='_modal-content'>
                        <div className='_modal-head'>
                            <h4>Ajouter une dépense</h4>
                            <button type='button' className='_modal-close'>&times;</button>
                        </div>
                        <div className='_modal-body'>
                            <form className='form' onSubmit={ handleSubmit }>
                                { errors && errors.error && <div className='alert alert-danger'>{ errors.error }</div> }
                                <div className='mb-3'>
                                    <label htmlFor='date' className='required'>Date</label>
                                    <input type='date' id='date' name='date' className='form-control' required placeholder='Date' autoComplete='off' value={ date } onChange={ (e) => setDate(e.target.value) } onBlur={ () => setIsDateTouched(true) } />
                                    { isDateTouched && date.length === 0 && <div className='form-error'>Veuillez sélectionner la date.</div> }
                                    { errors && errors.date && <div className='form-error'>{ errors.date[0] }</div> }
                                </div>
                                <div className='mb-3'>
                                    <label htmlFor='label' className='required'>Libellé</label>
                                    <input type='text' id='label' name='label' className='form-control' required placeholder='Libellé' autoComplete='off' value={ label } onChange={ (e) => setLabel(e.target.value) } onBlur={ () => setIsLabelTouched(true) } />
                                    { isLabelTouched && label.length === 0 && <div className='form-error'>Veuillez saisir le libellé.</div> }
                                    { isLabelTouched && label.length > 0 && label.length < 2 && <div className='form-error'>Le libellé est trop court. Veuillez saisir au moins 2 caractères.</div> }
                                    { errors && errors.label && <div className='form-error'>{ errors.label[0] }</div> }
                                </div>
                                <div className='mb-3'>
                                    <label htmlFor='description'>Description</label>
                                    <textarea id='description' name='description' maxLength={ 255 } className='form-control' placeholder='Description' value={ description } onChange={ (e) => setDescription(e.target.value) } onBlur={ () => setIsDescriptionTouched(true) }></textarea>
                                    { isDescriptionTouched && description.length > 0 && description.length < 10 && <div className='form-error'>La description est trop courte. Veuillez saisir au moins 10 caractères.</div> }
                                    { errors && errors.description && <div className='form-error'>{ errors.description[0] }</div> }
                                </div>
                                <div className='mb-3'>
                                    <label htmlFor='quantity' className='required'>Quantité</label>
                                    <input type='number' min={ 1 } step={ 1 } id='quantity' name='quantity' className='form-control' required placeholder='Quantité' autoComplete='off' value={ quantity } onChange={ (e) => setQuantity(e.target.value) } onBlur={ () => setIsQuantityTouched(true) } />
                                    { isQuantityTouched && quantity.length === 0 && <div className='form-error'>Veuillez saisir la quantité.</div> }
                                    { errors && errors.quantity && <div className='form-error'>{ errors.quantity[0] }</div> }
                                </div>
                                <div className='mb-3'>
                                    <label htmlFor='unit_price' className='required'>Prix unitaire</label>
                                    <input type='number' min={ 1 } step={ 0.01 } id='unit_price' name='unit_price' className='form-control' required placeholder='Prix unitaire' autoComplete='off' value={ unitPrice } onChange={ (e) => setUnitPrice(e.target.value) } onBlur={ () => setIsUnitPriceTouched(true) } />
                                    { isUnitPriceTouched && unitPrice.length === 0 && <div className='form-error'>Veuillez saisir le prix unitaire.</div> }
                                    { errors && errors.unit_price && <div className='form-error'>{ errors.unit_price[0] }</div> }
                                </div>
                                <div className='mb-3'>
                                    <label htmlFor='total_amount' className='required'>Total</label>
                                    <input type='number' readOnly id='total_amount' name='total_amount' className='form-control' required placeholder='Total' autoComplete='off' value={ totalAmount } />
                                    { errors && errors.total_amount && <div className='form-error'>{ errors.total_amount[0] }</div> }
                                </div>
                                <div className='pt-2 text-end'>
                                    <button type='submit' className='btn btn-primary btn-lg' disabled={
                                        date.length === 0 || label.length < 2 || (description.length > 0 && description.length < 10) || quantity.length === 0 || unitPrice.length === 0
                                    }><i className='fa fa-save'></i> Enregistrer</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div ref={ updateModalRef } className={ `_modal${ modal === 'update' && expense ? ' active' : '' }` }>
                    <div className='_modal-content'>
                        <div className='_modal-head'>
                            <h4>Modifier une dépense</h4>
                            <button type='button' className='_modal-close'>&times;</button>
                        </div>
                        <div className='_modal-body'>
                            <form className='form' onSubmit={ handleSubmit2 }>
                                { errors && errors.error && <div className='alert alert-danger'>{ errors.error }</div> }
                                <div className='mb-3'>
                                    <label htmlFor='_date' className='required'>Date</label>
                                    <input type='date' id='_date' name='date' className='form-control' required placeholder='Date' autoComplete='off' value={ date } onChange={ (e) => setDate(e.target.value) } onBlur={ () => setIsDateTouched(true) } />
                                    { isDateTouched && date.length === 0 && <div className='form-error'>Veuillez sélectionner la date.</div> }
                                    { errors && errors.date && <div className='form-error'>{ errors.date[0] }</div> }
                                </div>
                                <div className='mb-3'>
                                    <label htmlFor='_label' className='required'>Libellé</label>
                                    <input type='text' id='_label' name='label' className='form-control' required placeholder='Libellé' autoComplete='off' value={ label } onChange={ (e) => setLabel(e.target.value) } onBlur={ () => setIsLabelTouched(true) } />
                                    { isLabelTouched && label.length === 0 && <div className='form-error'>Veuillez saisir le libellé.</div> }
                                    { isLabelTouched && label.length > 0 && label.length < 2 && <div className='form-error'>Le libellé est trop court. Veuillez saisir au moins 2 caractères.</div> }
                                    { errors && errors.label && <div className='form-error'>{ errors.label[0] }</div> }
                                </div>
                                <div className='mb-3'>
                                    <label htmlFor='_description'>Description</label>
                                    <textarea id='_description' name='description' maxLength={ 255 } className='form-control' placeholder='Description' value={ description } onChange={ (e) => setDescription(e.target.value) } onBlur={ () => setIsDescriptionTouched(true) }></textarea>
                                    { isDescriptionTouched && description.length > 0 && description.length < 10 && <div className='form-error'>La description est trop courte. Veuillez saisir au moins 10 caractères.</div> }
                                    { errors && errors.description && <div className='form-error'>{ errors.description[0] }</div> }
                                </div>
                                <div className='mb-3'>
                                    <label htmlFor='_quantity' className='required'>Quantité</label>
                                    <input type='number' min={ 1 } step={ 1 } id='_quantity' name='quantity' className='form-control' required placeholder='Quantité' autoComplete='off' value={ quantity } onChange={ (e) => setQuantity(e.target.value) } onBlur={ () => setIsQuantityTouched(true) } />
                                    { isQuantityTouched && quantity.length === 0 && <div className='form-error'>Veuillez saisir la quantité.</div> }
                                    { errors && errors.quantity && <div className='form-error'>{ errors.quantity[0] }</div> }
                                </div>
                                <div className='mb-3'>
                                    <label htmlFor='_unit_price' className='required'>Prix unitaire</label>
                                    <input type='number' min={ 1 } step={ 0.01 } id='_unit_price' name='unit_price' className='form-control' required placeholder='Prix unitaire' autoComplete='off' value={ unitPrice } onChange={ (e) => setUnitPrice(e.target.value) } onBlur={ () => setIsUnitPriceTouched(true) } />
                                    { isUnitPriceTouched && unitPrice.length === 0 && <div className='form-error'>Veuillez saisir le prix unitaire.</div> }
                                    { errors && errors.unit_price && <div className='form-error'>{ errors.unit_price[0] }</div> }
                                </div>
                                <div className='mb-3'>
                                    <label htmlFor='_total_amount' className='required'>Total</label>
                                    <input type='number' readOnly id='_total_amount' name='total_amount' className='form-control' required placeholder='Total' autoComplete='off' value={ totalAmount } />
                                    { errors && errors.total_amount && <div className='form-error'>{ errors.total_amount[0] }</div> }
                                </div>
                                <div className='mb-3'>
                                    <label htmlFor='status' className='required'>Statut</label>
                                    <select id='status' name='status' className='form-control' required autoComplete='off' value={ status } onChange={ (e) => setStatus(e.target.value) } onBlur={ () => setIsStatusTouched(true) }>
                                        <option value="">Sélectionner</option>
                                        <option value="Draft">Brouillon</option>
                                        <option value="Taken">Pris en compte</option>
                                        <option value="Deleted">Supprimé</option>
                                    </select>
                                    { isStatusTouched && status.length === 0 && <div className='form-error'>Veuillez sélectionner le statut.</div> }
                                    { errors && errors.status && <div className='form-error'>{ errors.status[0] }</div> }
                                </div>
                                <div className='pt-2 text-end'>
                                    <button type='submit' className='btn btn-primary btn-lg' disabled={
                                        date.length === 0 || label.length < 2 || (description.length > 0 && description.length < 10) || quantity.length === 0 || unitPrice.length === 0 ||
                                        (modal === "update" && expense && date === expense.date && label === expense.label && ((expense.description === null && description.length === 0) || (expense.description !== null && expense.description === description)) && quantity === expense.quantity && unitPrice === expense.unit_price && status === expense.status)
                                    }><i className='fa fa-save'></i> Mettre à jour</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div ref={ detailsModalRef } className={ `_modal${ modal === 'details' && expense ? ' active' : '' }` }>
                    <div className='_modal-content'>
                        <div className='_modal-head'>
                            { expense &&
                            <h4>Dépense N° # { expense.id }</h4> }
                            <button type='button' className='_modal-close'>&times;</button>
                        </div>
                        <div className='_modal-body'>
                        { expense && <>
                            <div className='mb-3'>
                                <div className='_label'>ID</div>
                                <div className='_value'>#{ expense?.id }</div>
                            </div>

                            <div className='mb-3'>
                                <div className='_label'>Date</div>
                                <div className='_value'>{ dateFormat(expense?.date) }</div>
                            </div>

                            <div className='mb-3'>
                                <div className='_label'>Libellé</div>
                                <div className='_value'>{ expense?.label }</div>
                            </div>

                            <div className='mb-3'>
                                <div className='_label'>Quantité</div>
                                <div className='_value'>{ expense?.quantity }</div>
                            </div>

                            <div className='mb-3'>
                                <div className='_label'>Prix unitaire</div>
                                <div className='_value'>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(expense?.unit_price) }</div>
                            </div>

                            <div className='mb-3'>
                                <div className='_label'>Prix total</div>
                                <div className='_value'>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(expense?.total_amount) }</div>
                            </div>

                            <div className='mb-3'>
                                <div className='_label'>Statut</div>
                                <div className='_value'>{ expense.status === 'Draft' ? <span className='badge bg-dark'>Brouillon</span> : (expense.status === 'Taken' ? <span className='badge bg-success'>Pris en compte</span> : <span className='badge bg-danger'>Supprimé</span>) }</div>
                            </div>

                            <div className='pt-3 text-center'>
                                <button type='button' className='btn btn-lg btn-primary' onClick={ () => {
                                    setModal("update");
                                }}><i className='fa fa-edit'></i> Modifier</button>
                            </div>
                        </> }
                        </div>
                    </div>
                </div>

                <div className='filter'>
                    <div className='row'>
                        <div className='col-2'>
                            <label htmlFor='start_date'>De :</label>
                            <input type='date' id='start_date' value={ startDate } className='form-control' required onChange={ (e) => setStartDate(e.target.value) } />
                        </div>
                        <div className='col-2'>
                            <label htmlFor='end_date'>À :</label>
                            <input type='date' id='end_date' value={ endDate } className='form-control' required onChange={ (e) => setEndDate(e.target.value) } />
                        </div>
                    </div>
                </div>
                
                <div className='box'>
                    <table className='table table-striped'>
                        <thead>
                        <tr>
                            <th width="160">Date</th>
                            <th>Libellé</th>
                            <th width="140">Quantité</th>
                            <th width="140">PU en Ariary</th>
                            <th width="140">Total en Ariary</th>
                            <th width="140">Statut</th>
                            <th width="75" className="text-end">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                            { expenses.loading && <tr><td colSpan={ 7 }>Chargement...</td></tr> }
                            { expenses.loading === false && expenses.data && expenses.data.expenses && expenses.data.expenses.total === 0 && <tr><td colSpan={ 7 }>Aucun élément trouvé</td></tr> }
                            { expenses.loading === false && expenses.data && expenses.data.expenses && expenses.data.expenses.data && expenses.data.expenses.data.map((item, index) => {
                            return (
                            <tr key={ index }>
                                <td>{ dateFormat(item.date) }</td>
                                <td>{ item.label }</td>
                                <td>{ item.quantity }</td>
                                <td>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(item.unit_price) }</td>
                                <td>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(item.total_amount) }</td>
                                <td>{ item.status === 'Draft' ? <span className='badge bg-dark'>Brouillon</span> : (item.status === 'Taken' ? <span className='badge bg-success'>Pris en compte</span> : <span className='badge bg-danger'>Supprimé</span>) }</td>
                                <td className='text-end'>
                                    <div className='actions'>
                                        <button type='button' className='toggle-action' onClick={ (e) => {
                                            e.stopPropagation();
                                            setActionModal(actionModal !== item.id ? item.id : null);
                                        } }><i className='fa fa-ellipsis-v'></i></button>
                                        <ul className={ actionModal === item.id ? 'active' : '' }>
                                            <li><button onClick={ () => {
                                                setModal("details");
                                                setActionModal(null);
                                                setExpense(item);
                                            } }><i className='fa fa-eye'></i> Voir les détails</button></li>
                                            <li><button type='button' onClick={ () => {
                                                setActionModal(null);
                                                setExpense(item);
                                                setModal("update");
                                            } }><i className='fa fa-edit'></i> Modifier</button></li>
                                        </ul>
                                    </div>
                                </td>
                            </tr> ) })}
                        </tbody>
                    </table>
                </div>

                { expenses && expenses.data && expenses.data.expenseTotalAmount > 0 &&
                <>
                    <div className='box stat stat-4 mb-3'>
                        <div className='stat-icon'><i className='fa fa-money-bill'></i></div>
                        <div className='stat-value'>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(expenses.data.expenseTotalAmount > 1000000 ? (expenses.data.expenseTotalAmount / 1000000) : (expenses.data.expenseTotalAmount / 1000)) } { expenses.data.expenseTotalAmount > 1000000 ? 'M' : 'k' }</div>
                        <div className='stat-text'>d'Ariary de dépenses</div>
                    </div>
                </> }
                    
                { expenses && expenses.data &&
                <Paginate currentPage={ expenses.data.current_page } totalPages={ expenses.data.last_page } pathname={ location.pathname } search={ location.search } /> }
            </main>
        </HelmetProvider>
    )
}
